import React from 'react';
import autobind from 'autobind';
import { observer, inject } from 'mobx-react';

import { FieldVersionCard, FieldVersionCardProps } from './FieldVersionCard';
import { Entry } from '@patient/store/entry/Entry';
import { updateEntryFieldService } from '@patient/services/entry/updateEntryFieldService';
import { entryPageService } from '@patient/ui/shared/store';

interface Props extends FieldVersionCardProps {
    name: string;
}

interface StoreProps {
    entry: Entry;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const { entry, name, updateTime } = this.props;

        const entryVersion = entry.entryVersions.getExisting(updateTime);
        const field = entry.getVersionField(updateTime, name);
        const value = field ? field.getPreview() : '';
        const isHtml = field ? field.hasHtmlPreview : false;

        return React.createElement(FieldVersionCard, {
            value,
            isHtml,
            updateTime,
            author: entryVersion.author,
            isSigned: entryVersion.isSignedVersion,
            onRestoreClick: this.handleRestoreClick,
        });
    }

    @autobind
    protected async handleRestoreClick() {
        const { name, updateTime } = this.props;

        await updateEntryFieldService.restoreFieldValue(name, updateTime);

        entryPageService.resetRightContent();
    }
}

export const FieldVersionCardContainer = inject<Props, StoreProps>(Entry.Name)(Component);
